import React from 'react'
import AppAppBar from '../components/views/AppAppBar'

const Header = () => {
  return (
    <nav className="header">
      <AppAppBar />
    </nav>
  )
}

export default Header
